// extracted by mini-css-extract-plugin
export default {"reviewSlider":"QBVghW","reviewSliderControls":"abppAC","buttonLanding":"Vsxqsp","touchInterface":"TiUdKR","slide":"Gg3EEi"};